import { h } from 'preact';

interface StatusBadgeProps {
  status: string;
}

const statusConfig: Record<string, { label: string; color: string; icon: string }> = {
  registered: {
    label: 'Registro Completo',
    color: 'bg-blue-100 text-blue-800 border-blue-200',
    icon: '📝'
  },
  pending_approval: {
    label: 'Pendiente de Aprobación',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    icon: '🟡'
  },
  approved_pending_payment: {
    label: 'Pago Pendiente',
    color: 'bg-purple-100 text-purple-800 border-purple-200',
    icon: '💳'
  },
  active: {
    label: 'Activo',
    color: 'bg-green-100 text-green-800 border-green-200',
    icon: '✅'
  },
  rejected: {
    label: 'Rechazado',
    color: 'bg-red-100 text-red-800 border-red-200',
    icon: '❌'
  },
  inactive: {
    label: 'Inactivo',
    color: 'bg-gray-100 text-gray-800 border-gray-200',
    icon: '⚪'
  }
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.inactive;

  return (
    <span
      class={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${config.color}`}
      title={config.label}
    >
      <span class="mr-1">{config.icon}</span>
      {config.label}
    </span>
  );
}
